import { SVGProps } from "react";
const StarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id='\xF0\x9F\xA6\x86 emoji "white medium star"'>
      <path
        id="Vector"
        d="M6.40518 0.522135L7.75125 3.5923C7.85426 3.82731 8.07727 3.98832 8.33328 4.01132L11.6125 4.30534C11.9835 4.35934 12.1315 4.81436 11.8625 5.07638L9.39234 7.15149C9.19233 7.3195 9.10132 7.58351 9.15633 7.83852L9.87436 11.1997C9.93737 11.5687 9.55035 11.8507 9.21833 11.6757L6.35618 9.99964C6.13617 9.87063 5.86415 9.87063 5.64414 9.99964L2.78199 11.6747C2.45097 11.8487 2.06295 11.5677 2.12595 11.1987L2.84399 7.83752C2.89799 7.58251 2.80799 7.3185 2.60798 7.15049L0.136846 5.07738C-0.131169 4.81636 0.0168393 4.36034 0.386859 4.30634L3.66603 4.01232C3.92205 3.98932 4.14506 3.82831 4.24806 3.5933L5.59414 0.523135C5.76115 0.187117 6.23917 0.187117 6.40518 0.522135Z"
        fill="#FDD835"
      />
      <path
        id="Vector_2"
        d="M6.3072 3.77626L6.07919 1.51414C6.07019 1.38813 6.04418 1.17212 6.24619 1.17212C6.4062 1.17212 6.49321 1.50514 6.49321 1.50514L7.17724 3.32123C7.43526 4.01227 7.32925 4.24928 7.08024 4.38929C6.79422 4.5493 6.3722 4.42429 6.3072 3.77626Z"
        fill="#FFFF8D"
      />
      <path
        id="Vector_3"
        d="M9.12833 6.9501L11.0904 5.41902C11.1874 5.33801 11.3624 5.20901 11.2224 5.062C11.1114 4.94599 10.8114 5.113 10.8114 5.113L9.09433 5.78404C8.5823 5.96105 8.24228 6.22306 8.21228 6.55308C8.17328 6.9931 8.5683 7.33212 9.12833 6.9501Z"
        fill="#F4B400"
      />
    </g>
  </svg>
);
export default StarIcon;
